// this function will determine which transaction should be : sale | purchase
export function getInvoiceCode(transaction) {
    if (transaction.purchase) {
        return transaction.purchase.invoice_code
    } else {
        return transaction.sale.invoice_code
    }
}

export function getDeliverableType(transaction) {
    if (transaction.purchase) {
        return 'App\\PurchaseItem'
    } else {
        return 'App\\SaleItem'
    }
}

export function getDeliveredProgress(transaction) {
    let transactionType = transaction.purchase ? 'purchase' : 'sale'
    return {
        progress : transaction[transactionType].stock_delivered_progress,
        caption : transaction[transactionType].stock_delivered_caption
    }
}
